{
  "title": "Mein Profil",
  "subtitle": "Anzeigename, Telefonnummer und Passwort verwalten",
  "backToAdmin": "Zurück zur Administration",
  "backToManage": "Zurück zur Verwaltung",
  "backToClient": "Zurück zum Portal",
  "backToHome": "Zurück zur Startseite",
  "accountInfo": "Kontoinformationen",
  "editName": "Anzeigename",
  "namePlaceholder": "Ihr Name",
  "nameHint": "Dieser Name wird in der App angezeigt.",
  "saveName": "Name speichern",
  "nameUpdated": "Name erfolgreich aktualisiert",
  "nameUpdateFailed": "Name konnte nicht aktualisiert werden",
  "fields": {
    "email": "E-Mail",
    "name": "Name",
    "role": "Rolle",
    "phone": "Telefon",
    "emailVerified": "E-Mail bestätigt",
    "phoneVerified": "Telefon bestätigt",
    "memberSince": "Mitglied seit"
  },
  "verified": "Bestätigt",
  "notVerified": "Nicht bestätigt",
  "emailVerifiedTag": "E-Mail bestätigt",
  "emailNotVerifiedTag": "E-Mail nicht bestätigt",
  "phoneVerified": "Telefon bestätigt",
  "phoneNotVerified": "Telefon nicht bestätigt",
  "phoneSection": "Telefonnummer",
  "changePhone": "Telefonnummer ändern",
  "addPhone": "Telefonnummer hinzufügen",
  "phoneEmptyDescription": "Fügen Sie eine Telefonnummer hinzu, um nach der Bestätigung die SMS-Anmeldung zu nutzen.",
  "phoneVerifiedHint": "Diese Nummer ist bestätigt und kann für die SMS-Anmeldung verwendet werden.",
  "phoneUnverifiedHint": "Bestätigen Sie diese Nummer mit einem SMS-Code, bevor Sie die SMS-Anmeldung nutzen können.",
  "changePhoneHint": "Geben Sie eine neue Nummer ein und bestätigen Sie sie mit dem SMS-Code.",
  "copyPhone": "Nummer kopieren",
  "phoneCopied": "Kopiert",
  "sendCode": "Bestätigungscode senden",
  "resendCode": "Code erneut senden",
  "verifyPhone": "Telefonnummer bestätigen",
  "codeLabel": "Bestätigungscode",
  "codeRequired": "Geben Sie den 6-stelligen Code ein",
  "codeSent": "Bestätigungscode gesendet",
  "codeSendFailed": "Bestätigungscode konnte nicht gesendet werden",
  "codeVerifyFailed": "Telefonnummer konnte nicht bestätigt werden",
  "phoneVerifiedSuccess": "Telefonnummer erfolgreich bestätigt",
  "phoneRequired": "Telefonnummer ist erforderlich",
  "phoneInvalid": "Bitte geben Sie eine vollständige, gültige Telefonnummer ein",
  "phoneAlreadyUsed": "Diese Telefonnummer ist bereits mit einem anderen Konto verknüpft",
  "phoneAlreadyVerified": "Diese Telefonnummer ist bereits bestätigt",
  "invalidCode": "Ungültiger Bestätigungscode",
  "codeExpired": "Bestätigungscode abgelaufen. Bitte fordern Sie einen neuen an",
  "phoneManageUnavailable": "Telefonbestätigung ist für Ihre Kontorolle nicht verfügbar.",
  "notSet": "Nicht angegeben",
  "emailSection": "E-Mail",
  "addEmail": "E-Mail hinzufügen",
  "changeEmail": "E-Mail ändern",
  "emailEmptyDescription": "Fügen Sie eine E-Mail-Adresse hinzu, um nach der Bestätigung die E-Mail-Anmeldung zu nutzen.",
  "emailVerifiedHint": "Diese E-Mail ist bestätigt und kann für die Anmeldung mit Passwort verwendet werden.",
  "emailUnverifiedHint": "Öffnen Sie den Bestätigungslink oder senden Sie ihn erneut, falls Sie die E-Mail nicht erhalten haben.",
  "changeEmailHint": "Geben Sie eine neue Adresse ein. Wir senden einen Bestätigungslink, bevor sie aktiv wird.",
  "emailPlaceholder": "you@example.com",
  "emailRequired": "E-Mail ist erforderlich",
  "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  "sendEmailVerification": "Bestätigungs-E-Mail senden",
  "resendEmail": "Bestätigungs-E-Mail erneut senden",
  "emailVerificationSent": "Bestätigungs-E-Mail gesendet",
  "emailSendFailed": "Bestätigungs-E-Mail konnte nicht gesendet werden",
  "emailAlreadyUsed": "Diese E-Mail ist bereits mit einem anderen Konto verknüpft",
  "emailAlreadyVerified": "Diese E-Mail ist bereits bestätigt",
  "emailVerifiedReadOnly": "Eine bestätigte E-Mail kann hier nicht geändert werden",
  "security": "Sicherheit",
  "changePassword": "Passwort ändern",
  "currentPassword": "Aktuelles Passwort",
  "currentPasswordRequired": "Aktuelles Passwort ist erforderlich",
  "currentPasswordPlaceholder": "Aktuelles Passwort eingeben",
  "newPassword": "Neues Passwort",
  "confirmPassword": "Neues Passwort bestätigen",
  "confirmPasswordRequired": "Bitte bestätigen Sie Ihr neues Passwort",
  "updatePassword": "Passwort aktualisieren",
  "passwordUpdated": "Passwort erfolgreich aktualisiert",
  "passwordUpdateFailed": "Passwort konnte nicht aktualisiert werden",
  "passwordCreated": "Passwort erfolgreich erstellt",
  "createPassword": "Passwort erstellen",
  "createPasswordHint": "Erstellen Sie ein Passwort, um sich auch per E-Mail anzumelden.",
  "passwordHint": "Geben Sie Ihr aktuelles Passwort ein, um ein neues zu setzen.",
  "fixFormErrors": "Bitte korrigieren Sie die markierten Felder und versuchen Sie es erneut.",
  "errors": {
    "currentPasswordIncorrect": "Das eingegebene aktuelle Passwort ist falsch. Bitte versuchen Sie es erneut.",
    "passwordCannotBeChanged": "Ihr Passwort wird von Ihrem Anmeldeanbieter verwaltet und kann hier nicht geändert werden.",
    "passwordAlreadySet": "Ein Passwort ist bereits gesetzt. Nutzen Sie stattdessen Passwort ändern.",
    "authenticationRequired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    "forbidden": "Sie haben keine Berechtigung für diese Aktion.",
    "serverError": "Etwas ist schiefgelaufen. Bitte versuchen Sie es in Kürze erneut.",
    "loadFailed": "Profil konnte nicht geladen werden. Bitte laden Sie die Seite neu.",
    "networkError": "Server nicht erreichbar. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut."
  }
}
